export function usePrice() {
	const formatter = new Intl.NumberFormat('nl-NL', {
		style: 'currency',
		currency: 'EUR',
	});

	const toEuro = (value) => {
		return formatter.format(value);
	};

	return { toEuro };
}
